import Icon from '@/components/ui/AppIcon';

interface BenefitCardProps {
  icon: string;
  title: string;
  description: string;
}

function BenefitCard({ icon, title, description }: BenefitCardProps) {
  return (
    <div className="glass-card rounded-2xl p-8 hover:shadow-xl transition-all duration-300 reveal group">
      <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
        <Icon name={icon as any} size={28} className="text-primary" />
      </div>
      <h3 className="text-heading-4 text-foreground mb-3">{title}</h3>
      <p className="text-base text-muted-foreground leading-relaxed">{description}</p>
    </div>);

}

export default function WhyChooseSection() {
  const benefits = [
  {
    id: 'benefit_1',
    icon: 'BeakerIcon',
    title: 'Scientifically Formulated in Holland',
    description: 'Advanced European feed science tailored to Uganda\'s poultry farming conditions.'
  },
  {
    id: 'benefit_2',
    icon: 'ShieldCheckIcon',
    title: 'Consistent Nutrient Composition',
    description: 'Every batch maintains strict quality control standards to ensure reliable performance.'
  },
  {
    id: 'benefit_3',
    icon: 'ChartBarIcon',
    title: 'Improved Feed Conversion Ratios (FCR)',
    description: 'Optimized nutrient balance for maximum absorption and efficient growth.'
  },
  {
    id: 'benefit_4',
    icon: 'TrophyIcon',
    title: 'Higher Egg Yield & Faster Growth',
    description: 'Proven results showing 10–15% increase in egg production and accelerated broiler weight gain.'
  }];


  return (
    <section className="py-section px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4">Why Choose Bloom Animal Feeds</p>
          <h2 className="text-heading-2 md:text-[3rem] lg:text-heading-1 leading-tight text-foreground mb-6">
            Trusted by Progressive <br />
            <span className="gradient-text">Poultry Farmers</span>
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {benefits.map((benefit) =>
          <BenefitCard
            key={benefit.id}
            icon={benefit.icon}
            title={benefit.title}
            description={benefit.description} />

          )}
        </div>

        {/* Featured Image */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl reveal" style={{ animationDelay: '0.2s' }}>
          <div className="aspect-[21/9] bg-gradient-to-br from-green-100 to-green-50">
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1c8c0bf81-1764687936488.png"
              alt="White broiler chickens in modern poultry house with clean environment and optimal feeding systems"
              className="w-full h-full object-cover" />
            
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12 reveal" style={{ animationDelay: '0.3s' }}>
          <a
            href="/products"
            className="group inline-flex items-center justify-center gap-3 bg-[#2E7D32] text-white px-12 py-6 rounded-full text-lg font-bold hover:bg-[#66BB6A] hover:scale-110 transition-all duration-300 shadow-2xl hover:shadow-[0_25px_60px_rgba(46,125,50,0.5)]">
            <span>Explore Our Products</span>
            <Icon name="ArrowRightIcon" size={24} className="group-hover:translate-x-2 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </section>);

}